enum Pages {
    AboutUs = "",
    Service= "#service",
    Reference= "#reference",
    ContactForm= "#contact_form",
    ContactInfo= "#contact_info",
}

export default Pages;